<template>
  <div class="main">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>装备</el-breadcrumb-item>
        <el-breadcrumb-item>装备对比</el-breadcrumb-item>
        <el-breadcrumb-item>装备PK</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <xy-toolbox-menu>
      <xy-toolbox-menu-item custom>
        <div class="custom-content">
          <el-select v-model="viewValue" placeholder="选择显示形式" @change="changeViewOption">
            <el-option
              v-for="item in viewOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
      </xy-toolbox-menu-item>
      <xy-toolbox-menu-item divided />
      <xy-toolbox-menu-item icon="car_search" @click="gocompare">添加车款</xy-toolbox-menu-item>
      <xy-toolbox-menu-item icon="excel" @click="exportExcel">导出</xy-toolbox-menu-item>
    </xy-toolbox-menu>

    <div class="pk1box">
      <h3></h3>
      <div v-html="content"></div>
      <h3></h3>
    </div>
  </div>
</template>

<style>
</style>

<script>
const OptionPattern = /\(选装:(.*?)\)/g;
const HasDigit = /\d+/;
import { mapMutations, mapGetters, mapActions } from "vuex";
import SearchBar from "@/components/common/EquipSearch.vue";
import { formatDate, strToFormatDate } from "@/plugins/DateTimeFormater.js";
export default {
  name: "equippk1",
  data() {
    return {
      content: "",
      categories: [],
      pklist: [],
      pkids: [],
      paramData: [],
      queryParams: [],
      lines: [],
      excelData: [],
      viewValue: 1,
      viewOptions: [
        {
          value: 1,
          label: "显示+-"
        },
        {
          value: 2,
          label: "相同->"
        }
      ]
    };
  },
  methods: {
    ...mapActions("equipanalysis", ["queryEquipParams"]),
    async queryData() {
      var postData = {
        ids: this.pkids
      };
      this.queryEquipParams({
        params: postData
      });
    },
    test() {},
    changeViewOption() {
      this.bindData();
    },
    gocompare() {
      this.$router.push({
        name: "equipcompare"
      });
    },
    bindData() {
      this.margeEquip();
      //   this.pklist.forEach(x => {
      //     this.makeContent(x);
      //   });

      this.htmlContent();
    },
    htmlContent() {
      //   alert(JSON.stringify(this.queryParams ));

      var arrlen = this.queryParams.length;
      var html =
        '<div class="pk-content pk2" style="grid-template-columns:  ' +
        " auto".repeat(arrlen) +
        ';">';

      this.queryParams.forEach(x => {
        html += '<div class="item">' + x[0].name + "</div>";
      });
      this.queryParams.forEach(x => {
        html += '<div class="item"> MSRP :' + x[0].msrp + "</div>";
      });

      this.queryParams.forEach(x => {
        var pk1a = this.find_line(x[0].carId);
        var pk2a = this.find_line(x[1].carId);
        html += '<div class="item">  ' + this.pk(pk1a, pk2a, "", 1) + "</div>";
      });

      this.queryParams.forEach(x => {
        var pk1a = this.find_line(x[0].carId);
        var pk2a = this.find_line(x[1].carId);
        html +=
          '<div class="item">  ' +
          this.pk(pk2a, pk1a, "", 2, "ls-inferior") +
          "</div> ";
      });
      if (this.viewValue == 2) {
        this.queryParams.forEach(x => {
          var pk1a = this.find_line(x[0].carId);
          var pk2a = this.find_line(x[1].carId);
          html +=
            '<div class="item">  ' +
            this.pk(pk2a, pk1a, "", 3, "ls-different") +
            "</div> ";
        });
      }

      this.queryParams.forEach(x => {
        html += '<div class="item"> MSRP :' + x[1].msrp + "</div>";
      });
      this.queryParams.forEach(x => {
        html += '<div class="item">' + x[1].name + "</div>";
      });
      html += "</div>";
      this.content = html;
    },
    margeEquip() {
      var margeKeys = ["钥匙", "科技"];
      var filterKeys = ["参数", "动力"];
      var margeName = margeKeys.join(" & ");
      this.paramData = [];
      this.lines = this.equipParamsList.lines;
      for (const item of this.equipParamsList.categories) {
        if (filterKeys.findIndex(x => x == item.name) > -1) {
          continue;
        }
        if (margeKeys.findIndex(x => x == item.name) > -1) {
          continue;
        }
        this.categories.push(item);
      }
      this.categories.push({ id: -1, name: margeName });
      for (const item of this.equipParamsList.dataDict) {
        if (filterKeys.findIndex(x => x == item.tag) > -1) {
          continue;
        }

        if (margeKeys.findIndex(x => x == item.tag) > -1) {
          this.paramData.push({
            name: item.name,
            val: item.val,
            tag: margeName,
            lines: item.lines
          });
        } else {
          this.paramData.push(item);
        }
      }
      //alert(JSON.stringify(this.paramData));
    },

    //1优势装备 ，2 共有
    pk(equip1, equip2, cat, type, className) {
      var list = [];
      var fix = '';
      var clsName = "ls-goodness";
      if (className) {
        clsName = className;
      }  
        if(type==1)
        { fix ="+";}
        else if (type == 2) {
          clsName = "ls-public";
          fix ="-";
        } else if (type == 3) {
          clsName = "ls-different";
        }
      
        

      var html = "";
      var html = '<ul class="' + clsName + '">';
      equip1.forEach(x => {
        if (x.tag == cat || cat == "") {
          if (type == 1) {
            var fd = equip2.find(item => item.name == x.name);
            if (this.chk_item(x, fd, type)) {
              if (!HasDigit.test(x.val)) {
                html += "<li>" +fix  + x.val + " </li>";
              } else {
                html += "<li> "+fix  + x.name + ":" + x.val + "</li> ";
              }
            }
          } else if (type == 2) {
            var fd = equip2.find(item => item.name == x.name);
            if (!fd || fd.val != x.val) {
              if (!HasDigit.test(x.val)) {
                html += "<li>"+fix  + x.val + " </li>";
              } else {
                html += "<li> "+fix  + x.name + ":" + x.val + "</li> ";
              }
            }
          } else if (type == 3) {
            var fd = equip2.find(item => item.name == x.name);
            if (fd && fd.val != x.val) {
              if (!HasDigit.test(x.val)) {
                html += "<li> "+fix  + x.val + "->" + fd.val + "</li> ";
              } else {
                html +=
                  "<li> "+fix  + x.name + ": " + x.val + "->" + fd.val + "</li> ";
              }
            }
          }
        }
      });
      html += "</ul> ";
      return html;
    },
    chk_item(fd1, fd2, type) {
      if (type == 1) {
        if (this.viewValue == 1) {
          //显示+-
          if (!fd2 || fd2.val != fd1.val) {
            return true;
          }
        }
        if (this.viewValue == 2) {
          //-? 不显val不一至的装备
          if (!fd2) {
            return true;
          }
        }
      }
      return false;
    },
    find_line(id) {
      var result = [];
      var opts = [];
      var aaa;
      for (var i = 0; i < this.paramData.length; i++) {
        var r = this.paramData[i];
        for (var j in r.lines) {
          if (j == id) {
            var val = r.lines[j].replace(OptionPattern, "");

            if (val != "-" && val != "") {
              var line = {
                id: id,
                tag: r.tag,
                name: r.name,
                val: val
              };
              result.push(line);
            }
          }
        }
      }
      return result;
    },
    exportExcel() {
      var excelData = [];

      this.margeEquip();
      this.make_excel_rows(excelData);
      JSONToExcel(excelData, "装备竞争力分析", "equip");
    },
    make_excel_rows(excelData) {
      var arrlen = this.queryParams.length;

  //  var r0 = {};
  //     this.queryParams.forEach(x => {
  //       r0[x[0].name] = x[0].name;
  //     });
  //     excelData.push(r0);
         var r0 = {};
      this.queryParams.forEach(x => {
        r0[x[0].name] = "MSRP:"+x[0].msrp;
      });
      excelData.push(r0);
   

      var r1 = {};
      this.queryParams.forEach(x => {
        var pk1a = this.find_line(x[0].carId);
        var pk2a = this.find_line(x[1].carId);
        r1[x[0].name] = this.pk(pk1a, pk2a, "", 1);
      });
      excelData.push(r1);

      var r2 = {};
      this.queryParams.forEach(x => {
        var pk1a = this.find_line(x[0].carId);
        var pk2a = this.find_line(x[1].carId);
        r2[x[0].name] = this.pk(pk2a, pk1a, "", 2, "ls-inferior");
      });
      excelData.push(r2);

      if (this.viewValue == 2) {
        var r3 = {};
        this.queryParams.forEach(x => {
          var pk1a = this.find_line(x[0].carId);
          var pk2a = this.find_line(x[1].carId);
          r3[x[0].name] = this.pk(pk2a, pk1a, "", 3, "ls-different");
        });
        excelData.push(r3);
      }
      var r4 = {};
      this.queryParams.forEach(x => {
        r4[x[0].name] = "MSRP:"+x[1].msrp; 
      });
      excelData.push(r4);
      var r5 = {};
      this.queryParams.forEach(x => {
        r5[x[0].name] = x[1].name;
      });
      excelData.push(r5);
    }
  },
  mounted() {
    var params = this.$route.params.q;
    if (params == undefined) {
      return;
    }
    var ids = new Set();
    this.queryParams = params;
    params.forEach(x => {
      ids.add(x[0].carId);
      ids.add(x[1].carId);
    });
    this.pkids = [...ids];
    this.queryData();
  },
  computed: {
    ...mapGetters("equipanalysis", {
      equipParamsList: "equipParamsList"
    })
  },
  watch: {
    equipParamsList(value) {
      this.bindData();
    }
  }
};
</script>

